import React, { Component } from "react";
import styled from "styled-components";
import { Row, Col } from "reactstrap";

class Static extends Component {
  render() {
    const { label, children, labelCol, valueCol } = this.props;
    return (
      <StyledRow>
        <Col xs={labelCol || "3"}>{label}</Col>
        <Col xs={valueCol || "9"}>{children}</Col>
      </StyledRow>
    );
  }
}

const StyledRow = styled(Row)`
  margin-bottom: 7px;
  font-size: 14px;
`;

export default Static;



// WEBPACK FOOTER //
// ./src/components/Static.js